export default __webpack_public_path__ + "static/media/downloadAppQrUS.0502edcf.png";